export enum EElevatorType {
  Any = 'any',
  Service = 'service',
}
